import * as React from 'react';
import { useGlobalStore, useSearch } from 'src/hooks';
import { P14 } from 'src/components/atoms';
import { StyledBar, StyledPagination } from './TablePagination.styled';

export interface TablePaginationProps {
  totalPages: number;
  $small?: boolean;
  handlePageChangeCallback?: (page: number) => void;
  customCurrentPage?: number;
}

export const TablePagination: React.FunctionComponent<TablePaginationProps> = ({
  totalPages,
  $small = false,
  handlePageChangeCallback = undefined,
  customCurrentPage = undefined,
}) => {
  const prefersWideDashboardMenu = useGlobalStore((state) => state.prefersWideDashboardMenu);
  const [searchParams, setSearchParams] = useSearch();

  const currentPage = customCurrentPage || Number(searchParams?.page) || 1;

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    event.stopPropagation();
    if (typeof handlePageChangeCallback === 'function') {
      handlePageChangeCallback(page);
      return;
    }

    setSearchParams((prevSearchParams) => ({
      ...(prevSearchParams || {}),

      page,
    }));
  };

  if (typeof totalPages !== 'number' || totalPages <= 1) return null;

  return (
    <StyledBar $prefersWideDashboardMenu={prefersWideDashboardMenu} $small={$small}>
      <div>
        <P14 $fontWeight={600}>
          Page {currentPage} of {totalPages}
        </P14>
      </div>
      <StyledPagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        siblingCount={1}
        boundaryCount={1}
        shape="rounded"
      />
    </StyledBar>
  );
};
